<script>
/**
 * Base para validação de campos
 * Implementado solução semelhante ao Vuetify
 */
import {uniqueId} from 'lodash';

export default {
  name: 'VolanForm',
  global: true,
  provide() {
    // use function syntax so that we can access `this`
    return {
      volanForm: this,
    };
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: '',
    },
    disabled: Boolean,
    readonly: Boolean,
  },
  data(vm) {
    return {
      internalId: uniqueId('input_'),
      inputs: [],
      errors: [],
    };
  },
  computed: {
    computedId() {
      return this.id || `input-${this.internalId}`;
    },
  },
  methods: {
    /**
     * @public
     * @param goToError
     * @returns {Promise<{valid: boolean, errors: []}>}
     */
    async validate(goToError=false) {
      const results = [];
      let valid = true;
      this.errors = [];
      let _goToError = goToError;
      for (const item of this.inputs) {
        const itemErrorMessages = await item.validate?.();
        if (itemErrorMessages?.length > 0) {
          if(_goToError && item.$el?.offsetTop) {
            window.scrollTo({top: item.$el?.offsetTop-10, behavior: 'smooth'});
            _goToError = false;
          }
          valid = false;
          results.push({
            uid: item._uid,
            id: item.computedId,
            errorMessages: itemErrorMessages,
          });
        }
      }
      this.errors = results;
      return { valid, errors: this.errors };
    },
    /** @public */
    reset() {
      this.inputs.forEach(input => input.reset());
    },
    /** @public */
    resetValidation() {
      this.inputs.forEach(input => input.resetValidation());
    },
    register(input) {
      this.inputs.push(input);
    },
    unregister(input) {
      const index = this.inputs.findIndex(i => i._uid === input._uid);
      if (index===-1) return;
      this.inputs.splice(index, 1);
    },
  }
};
</script>
<template>
  <div class="box"
       v-bind="$attrs"
       v-on="$listeners"
  >
    <slot />
  </div>
</template>